import { usePostMutation } from "@/api/swr/useMutation";
import { contactInfoSchema } from "@/schema/free-assessment/ContactInfo";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof contactInfoSchema, z.ZodNull>
>[3];

export function useSendContactInfo(config: Config) {
  return usePostMutation(
    contactInfoSchema,
    z.null(),
    "/free_assessment/contact",
    config,
  );
}
